

export interface GuessRow {
  word: string;
  marks: string;
}
export type KeyState = "g" | "y" | "b";

const RANK: Record<KeyState, number> = { g: 3, y: 2, b: 1 };

/**
 * Best-known state per letter across all guesses: green beats yellow beats grey.
 * Pure, so the keyboard never disagrees with the grid.
 */
export function deriveKeyStates(guesses: GuessRow[]): Map<string, KeyState> {
  const out = new Map<string, KeyState>();
  for (const { word, marks } of guesses) {
    for (let i = 0; i < word.length; i++) {
      const letter = word[i] as string;
      const mark = marks[i] as KeyState | undefined;
      if (!mark) continue;
      const prev = out.get(letter);
      if (!prev || RANK[mark] > RANK[prev]) out.set(letter, mark);
    }
  }
  return out;
}

export const KEY_ROWS: string[][] = [
  ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
  ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
  ["z", "x", "c", "v", "b", "n", "m", "back"],
];
